module.exports = __webpack_public_path__ + "static/img/index_carousel3_2.e745826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/index_carousel3_2.jpg
// module id = srTy
// module chunks = 1